module.exports = __webpack_public_path__ + "img/out-of-budget-status-icon.a5265968.svg";